import React from "react";

import Layout from "../../component/layout/Layout";
import Hero from "../../sections/Hero";
import Compnay from "../../sections/Compnay";
import LmiaSection from "../../sections/LmiaSection";

const Home = () => {
  return (
    <Layout>
      <Hero />
      <LmiaSection/>
      <Compnay />
    </Layout>
  );
};

export default Home;
